module.exports = __webpack_public_path__ + "assets/08926d7a008503f9c640b1772c225476.woff";


//////////////////
// WEBPACK FOOTER
// ../~/@fontsource/roboto/files/roboto-all-500-normal.woff
// module id = 275
// module chunks = 121